import { useCallback, useState } from 'react';
import type { DependencyList } from 'react';
import { useEditor } from '@tiptap/react';
import type { Editor } from '@tiptap/react';
import type { Doc as YDoc } from 'yjs';

import { createPreviewExtensions } from 'Tiptap/editor-config';

interface ReadOnlyPreviewEditor {
  editor: Editor | null;
  contentApplied: boolean;
  markContentApplied: () => void;
}

export function useReadOnlyPreviewEditor(
  setTocContent: Parameters<typeof createPreviewExtensions>[0],
  ydoc: YDoc | null | undefined,
  deps: DependencyList
): ReadOnlyPreviewEditor {
  const editor = useEditor(
    {
      editable: false,
      immediatelyRender: false,
      extensions: createPreviewExtensions(setTocContent, ydoc ?? null),
    },
    deps
  );
  const [appliedEditor, setAppliedEditor] = useState<Editor | null>(null);

  const markContentApplied = useCallback(() => setAppliedEditor(editor), [editor]);

  return { editor, contentApplied: editor !== null && appliedEditor === editor, markContentApplied };
}
